import qs from "qs";
import {apiVoissa} from "../../libs/api";


export const fetchArticles = (query = {}, config = {}) => apiVoissa.get(`/articles?${qs.stringify(query)}`, config);

export const fetchArticle = (articleId, query = {}, config = {}) => apiVoissa.get(`/articles/${articleId}?${qs.stringify(query)}`, config);
export const createArticle = (data = {}, config = {}) => apiVoissa.post(`/articles`, data, config);
export const updateArticle = (articleId, data = {}, config = {}) => apiVoissa.patch(`/articles/${articleId}`, data, config);
export const deleteArticle = (articleId = null, config = {}) => apiVoissa.delete(`/articles/${articleId}`, config);
export const viewsArticle = (articleId, config = {}) => apiVoissa.patch(`/articles/${articleId}/view`, '', config);
export const reportArticle = (articleId, data = {}, config = {}) => apiVoissa.post(`/articles/${articleId}/reporting`, data, config);

export const fetchArticlesTag = (query = {}, config = {}) => apiVoissa.get(`/articles?${qs.stringify(query)}`, config);

export const ARTICLES_KEY = `articles`;

export const ARTICLE_KEY = `article`;
export const ARTICLE_COUNT_VIEW_KEY = `article-count-view`;
export const ARTICLE_TAGS_KEY = `article-tags`;